export enum AuthorityType {
  COUNTRY,
  STATE,
  CITY,
}
